export default __webpack_public_path__ + "static/media/S19.026babab.png";